export default __webpack_public_path__ + "static/media/issue.1f44c804.svg";